<!-- Falls nicht mindestens der Gesuchsteller 1 erfasst ist, eine Info anzigen, wie man die
EWK Suche starten kann -->
<h2>
    <span>{{ 'EWK_ABFRAGE_STARTEN' | translate }}</span>
    <dv-tooltip inputId="geres_info" [text]="'EWK_ABFRAGE_HINT' | translate">
    </dv-tooltip>
</h2>
@if (isGesuchsteller1New()) {
    <div class="well well-status-warten">
        <h3>{{ 'EWK_ABFRAGE_FEHLENDE_ANGABEN' | translate }}</h3>
    </div>
}
@if (!isGesuchsteller1New()) {
    <dv-loading-button
        type="button"
        buttonClass="dv-btn-operation trigger-search"
        (buttonClick)="searchGesuchsteller()"
    >
        <i class="fa fa-search"></i>
        {{ 'EWK_ABFRAGE_BUTTON' | translate }}
    </dv-loading-button>
    @for (person of personen$ | async; track person) {
        @if (person.gefunden) {
            <details class="person-found">
                <summary>
                    <span class="icons">
                        @if (person.gesuchsteller && person.isMaennlich()) {
                            <i
                                class="fa fa-male"
                                [title]="'EWK_IST_GESUCHSTELLER' | translate"
                            ></i>
                        }
                        @if (person.gesuchsteller && person.isWeiblich()) {
                            <i
                                class="fa fa-female"
                                [title]="'EWK_IST_GESUCHSTELLERIN' | translate"
                            ></i>
                        }
                        @if (person.kind) {
                            <i
                                class="fa fa-child"
                                [title]="'EWK_IST_KIND' | translate"
                            ></i>
                        }
                        @if (person.haushalt) {
                            <i
                                class="fa fa-building"
                                [title]="
                                    'EWK_WOHNT_IM_GLEICHEN_HAUSHALT' | translate
                                "
                            ></i>
                        }
                    </span>
                    {{ getShortDescription(person) }}
                    <i
                        class="fa"
                        [class.fa-mars]="person.isMaennlich()"
                        [class.fa-venus]="person.isWeiblich()"
                    ></i>
                </summary>
                <div class="person-details">
                    <div>
                        <span class="ewk-label">{{
                            'EWK_NACHNAME' | translate
                        }}</span>
                        {{ person.nachname }}
                    </div>
                    <div>
                        <span class="ewk-label">{{
                            'EWK_VORNAME' | translate
                        }}</span>
                        {{ person.vorname }}
                    </div>
                    <div>
                        <span class="ewk-label">{{
                            'EWK_GEBURTSDATUM' | translate
                        }}</span>
                        {{
                            person.geburtsdatum?.toISOString()
                                | date: 'shortDate'
                        }}
                    </div>
                    <div>
                        <span class="ewk-label">{{
                            'EWK_ZUZUGSDATUM' | translate
                        }}</span>
                        {{
                            person.zuzugsdatum?.toISOString()
                                | date: 'shortDate'
                        }}
                    </div>
                    <div>
                        <span class="ewk-label">{{
                            'EWK_WEGZUGSDATUM' | translate
                        }}</span>
                        {{
                            person.wegzugsdatum?.toISOString()
                                | date: 'shortDate'
                        }}
                    </div>
                    <div>
                        <span class="ewk-label">{{
                            'EWK_ZIVILSTAND' | translate
                        }}</span>
                        {{ person.zivilstand | translate }}
                    </div>
                    <div>
                        <span class="ewk-label">{{
                            'EWK_ZIVILSTAND_DATUM' | translate
                        }}</span>
                        {{
                            person.zivilstandsdatum?.toISOString()
                                | date: 'shortDate'
                        }}
                    </div>
                    <div>
                        <span class="ewk-label">{{
                            'EWK_GESCHLECHT' | translate
                        }}</span>
                        {{ person.geschlecht | translate }}
                    </div>
                    @if (person.adresse) {
                        <details class="adresse">
                            <summary>
                                {{ 'EWK_ADRESSE_TYP' | translate }}
                            </summary>
                            <dv-ewk-adresse
                                [adresse]="person.adresse"
                            ></dv-ewk-adresse>
                        </details>
                    }
                    @for (beziehung of person?.beziehungen; track beziehung) {
                        <details class="beziehung">
                            <summary>
                                {{ beziehung?.beziehungstyp | translate }}
                            </summary>
                            <div class="beziehung-details">
                                <div>
                                    <span class="ewk-label">{{
                                        'EWK_NACHNAME' | translate
                                    }}</span>
                                    {{ beziehung?.nachname }}
                                </div>
                                <div>
                                    <span class="ewk-label">{{
                                        'EWK_VORNAME' | translate
                                    }}</span>
                                    {{ beziehung?.vorname }}
                                </div>
                                <div>
                                    <span class="ewk-label">{{
                                        'EWK_GEBURTSDATUM' | translate
                                    }}</span>
                                    {{
                                        beziehung?.geburtsdatum?.toISOString()
                                            | date: 'shortDate'
                                    }}
                                </div>
                                @if (beziehung?.adresse) {
                                    <details class="adresse">
                                        <summary>
                                            {{ 'EWK_ADRESSE_TYP' | translate }}
                                        </summary>
                                        <dv-ewk-adresse
                                            [adresse]="beziehung?.adresse"
                                        ></dv-ewk-adresse>
                                    </details>
                                }
                            </div>
                        </details>
                    }
                </div>
            </details>
        } @else {
            <div class="person-not-found">
                <i
                    class="fa fa-exclamation-triangle"
                    [title]="'EWK_NICHT_GEFUNDEN' | translate"
                ></i>
                {{ getShortDescription(person) }}
            </div>
        }
    }
}
